import creator from '../elementCreator';
import globals from '../globals';
import wfsFormat from 'ol/format/WFS.js';
import Style from 'ol/style/Style.js';
import Icon from 'ol/style/Icon.js';
import * as olExtent from 'ol/extent';

"use strict"; 
var privateFns;

privateFns = {
	/** Funksjoner for søk **********************************************************************/
	customEncoder: function (str) {
		// Erstatter Æ
		str = globals.replaceAll("%C3%86", "%C6", str);
		str = globals.replaceAll("Æ", "%C6", str);

		// Erstatter Ø
		str = globals.replaceAll("%C3%98", "%D8", str);
		str = globals.replaceAll("Ø", "%D8", str);

		// Erstatter Å
		str = globals.replaceAll("%C3%85", "%C5", str);
		str = globals.replaceAll("Å", "%C5", str);

		// Erstatter bokstaven Ö
		str = globals.replaceAll("Ö", "%D6", str);
		str = globals.replaceAll("%C3%96", "%D6", str);

		// Erstatter bokstaven È
		str = globals.replaceAll("È", "%C8", str);
		str = globals.replaceAll("%C3%88", "%C8", str);

		// Erstatter bokstaven É
		str = globals.replaceAll("É", "%C9", str);
		str = globals.replaceAll("%C3%89", "%C8", str);

		// Erstatter single quote med grave accent
		str = globals.replaceAll("\"", "%60", str);
		str = globals.replaceAll("%27", "%60", str);

		// Erstatter Ä
		str = globals.replaceAll("Ä", "%C4", str);
		str = globals.replaceAll("%C3%84", "%C4", str);

		// Ertatter Ü
		str = globals.replaceAll("Ü", "%DC", str);
		str = globals.replaceAll("%C3%9C", "%DC", str);
		
		return str;
	},
	fixedEncodeURIComponent: function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
			return '%' + c.charCodeAt(0).toString(16);
		});
	},
	showExtendedMenu: function () {
		$(".featureinfo").addClass("almost-hide-right");
		$(".featureinfo-details").addClass("featureinfo-details-show");
	},
	newWfsFormat: function (typeName) {
		return new wfsFormat({
			featureNS: "http://mapserver.gis.umn.edu/mapserver",
			featureType: typeName
		});
	},
	readWfsFeatures: function (format, response) {
		return format.readFeatures(response, {
			dataProjection: "EPSG:32632",
			featureProjection: "EPSG:32632"
		});
	},
	sortByRelevance: function (collection, value) {
		collection.sort(function (a, b) {
			var aStart, bStart, order = -1;
			aStart = a.get("ADRESSE").match(new RegExp("^" + value, "i")) || [];
			bStart = b.get("ADRESSE").match(new RegExp("^" + value, "i")) || [];
			if (aStart.length !== bStart.length) {
				order = bStart.length - aStart.length;
			} else if (a.get("ADRESSE") > b.get("ADRESSE")) {
				order = 1;
			}
			return order;
		});
		return collection;
	},
	createSearchResultsPage: function () {
		var resultPage = $("#search-result-page");
		if (resultPage.length > 0) {
			resultPage.remove();
		}

		var page = creator.createDiv({id: "search-result-page"});

		var loader = creator.createDiv({id: "search-result-loader"});
		var loaderIcon = creator.createIcon({css: "fa fa-spinner fa-pulse"});
		var loaderSRSpan = creator.createSpan({css: "sr-only", text: "Søker..."});

		loader.appendChild(loaderIcon);
		loader.appendChild(loaderSRSpan);
		page.appendChild(loader);

		var topCloseBtn = creator.createButton({css: "close top", text: "Lukk", 
			onclick: function (e) {
				$(e.currentTarget.parentElement).remove();
			}
		});
		page.appendChild(topCloseBtn);

		/* Target for søkeresultater */
		var resultDiv = creator.createDiv({id: "search-result-ct"});
		page.appendChild(resultDiv);

		$("#searchinput").append(page).addClass("show-results");
	},
	zoomToFeatureCollection: function (features, addFeaturesToOverlay) {
		var minE = 999999, maxE = 111111, minN = 9999999, maxN = 1111111;
		features.forEach(function (f) {
			var extent = f.getGeometry().getExtent();
			if (extent[0] < minE) {
				minE = extent[0];
			}
			if (extent[1] < minN) {
				minN = extent[1];
			}
			if (extent[2] > maxE) {
				maxE = extent[2];
			}
			if (extent[3] > maxN) {
				maxN = extent[3];
			}
		});
		globals.map.getView().fit(
			[minE, minN, maxE, maxN]
		);
		if (addFeaturesToOverlay) {
			globals.addFeaturesToOverlay(features, "searchhighlight");
		}
	},
	zoomToFeature: function (e) {
		var input = $("#large-search");
		input.val($(e.currentTarget).html());
		if (!globals.multiEiendom) {
			globals.clearMap();
		}
		if ($(e.currentTarget).data("type") === "address") {
			globals.map.getLayerById("fontmarkers").getSource().addFeature($(e.currentTarget).data("features"));
			globals.map.getView().setCenter($(e.currentTarget).data("features").getGeometry().getCoordinates());
			globals.map.getView().setZoom(9);
		} else {
			/**
			 * @type {*}
			 * @param format.bounds
			 */
			var features = $(e.currentTarget).data("features");
			if (features[0].getId().indexOf("Planer_uten_flate") >= 0) {
				privateFns.zoomToFeatureCollection(features, true);
			} else {
				globals.map.getView().fit(
					features[0].getGeometry().getExtent()
				);
				$("body").css("cursor", "wait");
				globals.highlightPlan($(e.currentTarget).data("planid"));
			}
		}
	},
	zoomToBounds: function (format, r) {
		/**
		 * @type {*}
		 * @param format.bounds
		 */
		globals.map.getView().fit(
			olExtent.buffer(
				format.readFeatureCollectionMetadata(r).bounds,
				50
			)
		);
	},
	createResultsetButton: function (params) {
		var btn = creator.createButton({css: "zoom-to-search-result", text: params.html, onclick: privateFns.zoomToFeature});
		$(btn).data("type", params.type);
		$(btn).data("features", params.features);
		if (params.planid) {
			$(btn).data("planid", params.planid);
		}
		return btn;
	},
	listResultset: function (features, key) {
		var target = $("#search-result-ct");
		if (features.length) {
			features.forEach(function (f) {
				target.append(privateFns.createResultsetButton({
					html: f.get(key),
					type: "address",
					features: f
				}));
			});
		} else {
			Object.keys(features).some(function (objKey) {
				var done = false;
				if (Object.keys(features).length === 1) {
					privateFns.zoomToFeatureCollection(features[objKey].features, true);
					done = true;
					$("#search-result-page").remove();
				} else {
					target.append(privateFns.createResultsetButton({
						html: objKey,
						type: "plan",
						features: features[objKey].features,
						planid: features[objKey].planid
					}));
				}
				return done;
			});
		}
		globals.exposedGetPlanMetadata(key, $("#featureinfo-details-ct"));
	},
	processPlanFeatures: function (features) {
		/* Egen funksjon for å slå samme eventuelle features som gjelder samme plan. Dette gjelder spesielt
		 planer uten egen flate (typename = 'Planer_uten_flate')
		 */
		var planObj = {};
		var plannavn;
		features.forEach(function (feature) {
			plannavn = feature.get("PLANNAVN");
			if (planObj[plannavn]) {
				planObj[plannavn].features.push(feature);
			} else {
				planObj[plannavn] = {
					features: [feature],
					planid: feature.get("PLANID")
				};
			}
		});
		privateFns.listResultset(planObj, plannavn);
	},
	makeAddressByggesakRequest: function (params) {
		$.ajax({
			url: params.url,
			success: function (response) {
				var format = privateFns.newWfsFormat(params.typeName);
				var features = privateFns.readWfsFeatures(format, response);
				var inputField = $("#search-large");
				if (!globals.multiEiendom) {
					globals.clearMap();
				}
				if (features.length === 1) {
					$("#search-result-page").remove();
					inputField.val(features[0].get(params.valueField));
					var feature = features[0];
					feature.setStyle(new Style({
						image: new Icon({
							anchor: [0.5, 1],
							size: [32, 32],
							src: './icons/Kart PinBlue.png',
						}),
					}));
					globals.map.getLayerById("fontmarkers").getSource().addFeatures([feature]);
					globals.map.getView().setCenter(features[0].getGeometry().getCoordinates());
					globals.map.getView().setZoom(9);
					if ($(window).width() < 767) {
						$("#searchinput").removeClass("show-item");
					}
					if (params.typeName === "byggesak_sok") {
						features[0].set("contextId", "saker");
						if(globals.appConfig.contextMenu.active){							
							globals.handleMapClick(features[0].getGeometry().getCoordinates(), "sak", globals.appConfig, features[0]);
						}
					} else {
						if(globals.appConfig.contextMenu.active){							
							globals.handleMapClick(features[0].getGeometry().getCoordinates(), "sok", globals.appConfig);
						}		
					}
				} else if (features.length > 1) {
					features = privateFns.sortByRelevance(features, params.inputValue);
					privateFns.listResultset(features, params.valueField);
					$("#search-result-loader").hide();
				} else {
					$("#search-result-ct").html("Søket ga ingen treff");
				}
			},
			fail: function (response) {
				console.error(response);
			},
			error: function (response) {
				console.error(response);
			}
		});
	},
	makePropertyRequest: function (params) {
		$.ajax({
			url: params.url,
			success: function (response) {
				var format = privateFns.newWfsFormat(params.typeName);
				var features = privateFns.readWfsFeatures(format, response);
				$("#search-result-loader").hide();
				if (features.length > 0) {
					if (!globals.multiEiendom) {
						globals.clearMap();
					}
					privateFns.zoomToBounds(format, response);
					$("#search-large").val(features[0].get("GARDSNR") + "/" + features[0].get("BRUKSNR"));
					globals.addFeaturesToOverlay(features, "markers");
				}
				if (features.length === 1) {
					$("#search-result-page").remove();
					if (globals.appConfig.contextMenu.active) {
						if (features[0].getGeometry().getInteriorPoints) {
							globals.handleMapClick(features[0].getGeometry().getInteriorPoints().getCoordinates()[0], "sok", globals.appConfig);
						} else {
							globals.handleMapClick(features[0].getGeometry().getInteriorPoint().getCoordinates(), "sok", globals.appConfig);
						}
					}
					if ($(window).width() < 767) {
						$("#searchinput").removeClass("show-item");
					}
				} else if (features.length > 1) {
					$("#search-result-ct").append("Eiendommen består av " + features.length + " teiger (eiendomsdeler). Klikk i kartet på en av eiendomsdelene for å få opp informasjon om eiendommen.");
				} else {
					$("#search-result-ct").html("Søket ga ingen treff");
				}
			},
			fail: function (response) {
				console.error(response);
			},
			error: function (response) {
				console.error(response);
			}
		});
	},
	makePropertyListRequest: function (list) {
		var featureCollection = [];
		list.forEach(function (params) {
			$.ajax({
				url: params.url,
				success: function (response) {
					var format = privateFns.newWfsFormat(params.typeName);
					var features = privateFns.readWfsFeatures(format, response);
					features.forEach(function (f) {
						featureCollection.push(f);
					});
					$("#search-result-loader").hide();
					if (features.length > 0) {
						$("#search-large").val(features[0].get("GARDSNR") + "/" + features[0].get("BRUKSNR"));
						globals.addFeaturesToOverlay(features, "markers");
					}
					if (features.length === 1) {
						$("#search-result-page").remove();
						if ($(window).width() < 767) {
							$("#searchinput").removeClass("show-item");
						}
					} else if (features.length > 1) {
						$("#search-result-ct").append("Eiendommen består av " + features.length + " seksjoner eller teiger (eiendomsdeler). Klikk i kartet på en av eiendomsdelene for å få opp informasjon om eiendommen.");
					} else {
						$("#search-result-ct").html("Søket ga ingen treff");
					}
					privateFns.zoomToFeatureCollection(featureCollection, false);
					globals.listSearch = false;
				},
				fail: function (response) {
					console.error(response);
					globals.listSearch = false;
				},
				error: function (response) {
					console.error(response);
					globals.listSearch = false;
				}
			});
		});
	},
	makePlanRequest: function (params) {
		$(".featureinfo-details").addClass("aside-show standalone").removeClass("featureinfo-details-show");
		$.ajax({
			url: params.url,
			success: function (response) {
				var format = privateFns.newWfsFormat(params.typeName);
				var features = privateFns.readWfsFeatures(format, response);
				$("#search-result-loader").hide();
				if (features.length === 1) {
					$("#search-large").val(features[0].get("PLANNAVN"));
					$("#search-result-page").remove();
					$("body").css("cursor", "wait");
		
					if (!globals.multiEiendom) {
						globals.clearMap();
					}
					globals.highlightPlan(features[0].get("PLANID"));

					privateFns.zoomToBounds(format, response);
					if ($(window).width() < 767) {
						$("#searchinput").removeClass("show-item");
					}
					if ($(window).width() < 992) {
						$(".featureinfo-details").addClass("aside-show featureinfo-details-minimized standalone")
							.removeClass("featureinfo-details-show")
							.find(".maximize-this").html(features[0].get("PLANNAVN"));
					} else {
						$(".featureinfo-details").addClass("aside-show standalone")
							.removeClass("featureinfo-details-show");
					}
					// Skjuler kontekstmeny
					$(".featureinfo").removeClass("almost-hide-right aside-show");
					globals.exposedGetPlanMetadata(features[0].get("PLANNAVN"), $("#featureinfo-details-ct"));
			
				} else if (features.length > 1) {
					privateFns.processPlanFeatures(features);
				} else {
					if (params.inputValue) {
						if (isNaN(params.inputValue) === false && params.typeName !== "byggesak_sok") {
							privateFns.searchByggesak(params.inputValue);
						} else {
							$("#search-result-ct").html("Søket ga ingen treff");
						}
					} else {
						$("#search-result-ct").html("Søket ga ingen treff");
					}
				}
			},
			fail: function (response) {
				console.error(response);
			},
			error: function (response) {
				console.error(response);
			}
		});
	},
	getLookupAdresse: function (e) {
		$("#large-search").val(e.target.innerHTML);
		privateFns.createSearchResultsPage();
		var url = globals.searchUrl;
		url += "&VERSION=1.1.0&SERVICE=WFS&REQUEST=GetFeature&TYPENAME=ADRESSEID_WFS&Filter=";
		url += "<Filter><PropertyIsEqualTo><PropertyName>ADRID</PropertyName><Literal>" + e.target.id.toUpperCase() + "-</Literal></PropertyIsEqualTo></Filter>";
		privateFns.makeAddressByggesakRequest({
			url: url,
			typeName: "ADRESSEID_WFS",
			valueField: "ADRESSE",
			exact: true
		});
	},
	getLookupPlanPriv: function (value) {
		if(globals.intranett){
			value = privateFns.customEncoder(privateFns.fixedEncodeURIComponent(value));				
		}else{				
			value = privateFns.fixedEncodeURIComponent(value);
		}
		var url = globals.planinnsynUrl + "&service=WFS&version=1.1.0&request=GetFeature&";
		url += "typeName=Reguleringomr_Agg,Planer_uten_flate&Filter=";
		url += "(<Filter><PropertyIsEqualTo><PropertyName>PLANNAVNSTR</PropertyName><Literal>" + value.toUpperCase() + "-str</Literal></PropertyIsEqualTo></Filter>)";
		url += "(<Filter><PropertyIsEqualTo><PropertyName>PLANNAVNSTR</PropertyName><Literal>" + value.toUpperCase() + "-str</Literal></PropertyIsEqualTo></Filter>)";
		url += "&v=102";
		privateFns.createSearchResultsPage();
		privateFns.makePlanRequest({
			url: url,
			typeName: ["Reguleringomr_Agg", "Planer_uten_flate"],
			inputValue: value
		});
	},
	getLookupStedsnavnPriv: function (value) {
		var url = globals.searchUrl;
		$("#large-search").val(value);
		value = value.toUpperCase().trim();
		if(globals.intranett || (/*@cc_on!@*/false || !!document.documentMode)){
			value = privateFns.customEncoder(value);
		}
		url += "&VERSION=1.1.0&SERVICE=WFS&REQUEST=GetFeature&TYPENAME=STEDSNAVN_WFS&Filter=";
		url += "<Filter><PropertyIsEqualTo><PropertyName>ADRESSE</PropertyName><Literal>" + value + "</Literal></PropertyIsEqualTo></Filter>";
		privateFns.makeAddressByggesakRequest({
			url: url,
			typeName: "STEDSNAVN_WFS",
			valueField: "ADRESSE",
			exact: true
		});
	},
	searchAddress: function (value) {
		var url = globals.searchUrl;
		value = value.toUpperCase();
		value = privateFns.customEncoder(value);
		url += "&VERSION=1.1.0&SERVICE=WFS&REQUEST=GetFeature&TYPENAME=ADR_CONCAT&Filter=";
		url += "(<Filter><PropertyIsLike wildcard='*' singleChar='.' escape='!'><PropertyName>ADRESSE</PropertyName><Literal>*" + value + "*</Literal></PropertyIsLike></Filter>)";
		privateFns.makeAddressByggesakRequest({
			url: url,
			typeName: ["ADR_CONCAT"],
			inputValue: value,
			valueField: "ADRESSE"
		});
	},
	searchProperty: function (value) {
		var url = globals.searchUrl + "&VERSION=1.1.0&SERVICE=WFS&REQUEST=GetFeature&TYPENAME=EIENDOM_WFS&Filter=<Filter><AND><PropertyIsEqualTo><PropertyName>GARDSNR</PropertyName><Literal>" + value.split("/")[0] + "</Literal></PropertyIsEqualTo><PropertyIsEqualTo><PropertyName>BRUKSNR</PropertyName><Literal>" + value.split("/")[1] + "</Literal></PropertyIsEqualTo></AND></Filter>";
		privateFns.makePropertyRequest({
			url: url,
			typeName: "EIENDOM_WFS",
			noZoom: false
		});
	},
	searchListProperty: function (list) {
		var eiendomList = [];
		list.forEach(function (value) {
			var url = globals.searchUrl + "&VERSION=1.1.0&SERVICE=WFS&REQUEST=GetFeature&TYPENAME=EIENDOM_WFS&Filter=<Filter><AND><PropertyIsEqualTo><PropertyName>GARDSNR</PropertyName><Literal>" + value.split("/")[0] + "</Literal></PropertyIsEqualTo><PropertyIsEqualTo><PropertyName>BRUKSNR</PropertyName><Literal>" + value.split("/")[1] + "</Literal></PropertyIsEqualTo></AND></Filter>";
			eiendomList.push({url: url, typeName: "EIENDOM_WFS", noZoom: false});
		});
		privateFns.makePropertyListRequest(eiendomList);
	},
	searchPlannr: function (value) {
		var url = globals.planinnsynUrl + "&service=WFS&version=1.1.0&request=GetFeature&";
		url += "typeName=Reguleringomr_Agg,Planer_uten_flate&Filter=";
		url += "(<Filter><PropertyIsLike wildcard='*' singleChar='.' escape='!'><PropertyName>PLANNAVN</PropertyName><Literal>*" + value.toUpperCase() + "*</Literal></PropertyIsLike></Filter>)";
		url += "(<Filter><PropertyIsLike wildcard='*' singleChar='.' escape='!'><PropertyName>PLANNAVN</PropertyName><Literal>*" + value.toUpperCase() + "*</Literal></PropertyIsLike></Filter>)";
		url += "&v=102";
		privateFns.makePlanRequest({
			url: url,
			typeName: ["Reguleringomr_Agg", "Planer_uten_flate"],
			inputValue: value
		});
	},
	searchByggesak: function (value) {
		var url = globals.sakWFSUrl + "&version=1.1.0&service=wfs&request=GetFeature&srs=EPSG:4326&typename=byggesak_sok&Filter=<Filter><PropertyIsEqualTo><PropertyName>S</PropertyName><Literal>" + value + "</Literal></PropertyIsEqualTo></Filter>";
		$("#search-result-loader").show();
		privateFns.makeAddressByggesakRequest({
			url: url,
			typeName: "byggesak_sok",
			valueField: "S",
			inputValue: value
		});
	},
	searchCoordinate: function (value) {
		var coords = value.split("|"), numCoords = [];
		if (coords[0].length === 7 && coords[1].length === 6) {
			coords.reverse();
		}
		coords.forEach(function (coord) {
			numCoords.push(parseInt(coord, 10));
		});

		if (coords[0].length === 6 && coords[1].length === 7) {
			var feature = new ol.Feature({
				name: "coordPos",
				geometry: new ol.geom.Point(numCoords)
			});
			globals.map.getLayerById("fontmarkers").getSource().addFeature(feature);
			globals.map.getView().setCenter(feature.getGeometry().getCoordinates());
			globals.map.getView().setZoom(9);
			$("#search-result-page").remove();
		} else {
			$("#search-result-ct").append("Du tastet inn feil koordinater.");
			$("#search-result-loader").hide();
		}
	},
};

export default {
	lookupAdresserForGate: function (value) {
		privateFns.createSearchResultsPage();
		$.ajax({
			url: globals.phpAutocomplete + "prefetchHusnrForGate?gate=" + encodeURIComponent(value),
			success: function (adresser) {
				var target = $("#search-result-ct");
				adresser.forEach(function (adresse) {
					var btn = creator.createButton({id: adresse.id, css: "zoom-to-search-result", text: adresse.value, onclick: privateFns.getLookupAdresse});
					target.append(btn);
				});
				target.find("div:nth-of-type(1)").focus();
				$("#search-result-loader").hide();
			}
		});
	},
	getLookupPlan: privateFns.getLookupPlanPriv,
	getLookupStedsnavn: function (value) {
		privateFns.createSearchResultsPage();
		privateFns.getLookupStedsnavnPriv(value);
	},
	submitSearch: function (value) {
		value = value.trim();
		if (!globals.multiEiendom) {
			globals.clearMap();
		}
		if (!globals.listSearch) {
			if (value.length > 0) {
				privateFns.createSearchResultsPage();
				if (value.indexOf("/") > 0 && value.indexOf(",") < 0) {
					privateFns.searchProperty(value);
				} else if (value.indexOf("|") > 0) {
					privateFns.searchCoordinate(value);
				} else if (!isNaN(value)) {
					privateFns.searchPlannr(value);
				} else if (value.indexOf("/") > 0 && value.indexOf(",") > 0) {
					var values = value.split(",");
					privateFns.searchListProperty(values);
				} else {
					if (value.charAt(1) === "-" || !isNaN(parseInt(value.charAt(1), 10))) {
						privateFns.searchPlannr(value);
					} else {
						privateFns.searchAddress(value);
					}
				}
			}
		} else {
			var list = value.split(",");
			privateFns.searchListProperty(list);
		}
	},
};